import { mapperLotteries } from '~/utils/mappers/detail_result'

const initialState = {
	loading: false,
	lottery_id: null,
	lotteries: null,
	pagination: null,
	detail: null,
	current_page: 1,
	select_position: null,
}

/** Pinia store for the prize-detail history view. Holds paginated draw results for a lottery. */
export const useDetailResultStore = defineStore('detail-result', {
	state: () => ({ ...initialState }),
	actions: {
		/** Sets any top-level state property by key. */
		SET_STATE_DETAIL_RESULT({ type, value }) {
			this[type] = value
		},
		/** Fetches paginated draw history for a regular lottery and maps dates to the given locale. */
		async fetchDetailResult(params, locale = 'en') {
			const { $repository } = useNuxtApp()
			this.loading = true
			const response = await $repository.lotteries.prizes.getPrizeDetail(params)
			this.loading = false
			if (response.success === false) return response
			this.lottery_id = response?.result?.lottery_id
			this.lotteries = mapperLotteries(response?.result?.lotteries, locale)
			this.pagination = response?.result?.pagination

			return response
		},
		/** Fetches paginated draw history for a classic (Saturday-style) lottery. */
		async fetchDetailResultSaturday(params, locale = 'en') {
			const { $repository } = useNuxtApp()
			this.loading = true
			const response = await $repository.lotteries.classicPrizes.getPrizeClassicDetail(params)
			this.loading = false
			if (response.success === false) return response
			this.lottery_id = response?.result?.lottery_id
			this.lotteries = mapperLotteries(response?.result?.lotteries, locale)
			this.pagination = response?.result?.pagination

			return response
		},
	},
})
